<!-- /////////////////////////////////////////////////////////////////////////// TEMPLATE -->

<template>

    <div class="sl-card">

        <!-- title -->
        <div class="sl-card__title">
            {{ $t('return_table.details.section.return_questionnaire.title') }}
        </div>

        <!-- key/value in line -->
        <template v-for="retQuest in returnQuestionnaire">
            <!-- eslint-disable-next-line vue/require-v-for-key -->
            <div class="sl-card-details__label">
                {{ retQuest.question }}:
            </div>
            <!-- eslint-disable-next-line vue/require-v-for-key -->
            <div class="sl-card-details__value">
                {{ retQuest.answer }}
            </div>
        </template>

    </div>

</template>

<!-- /////////////////////////////////////////////////////////////////////////// SCRIPT -->

<script>

export default
{
    name: 'ReturnQuestionnaireAnswersCard',

    props:
    {
        oReturn:
        {
            type:     Object,
            required: true,
        },
    },

    computed:
    {
        returnQuestionnaire()
        {
            const collection = [];

            // Order
            for(const retQuest of this.oReturn.return_questionnaire_answers)
            {
                const qtkey = `parameters.${retQuest.question_code}.label`;
                const atkey = `parameters.${retQuest.question_code}.values.${retQuest.answer}.label`;

                const question = this.$te(qtkey) ? this.$t(qtkey) : retQuest.question_code;
                const answer = this.$te(atkey) ? this.$t(atkey) : retQuest.answer;

                collection.push({
                    question_code: retQuest.question_code,
                    question:      question,
                    answer:        answer,
                });
            }

            return collection;
        },
    },
};

</script>

<!-- /////////////////////////////////////////////////////////////////////////// STYLE -->

<style lang="scss" scoped>



</style>
